import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { HeadWeightNumberLookup } from '../../api/models';

export type TABLE_TYPE = Table<HeadWeightNumberLookup>;

export const TABLE = 'headWeightNumberLookup';
const SCHEMA = 'headWeightNumberLookupId, sortId';

class HeadWeightNumberLookupDatabase implements DataRepository<HeadWeightNumberLookup> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  // common methods:
  get(key: Key): Promise<HeadWeightNumberLookup | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: HeadWeightNumberLookup, key: Key): Promise<HeadWeightNumberLookup> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: HeadWeightNumberLookup[]): Promise<HeadWeightNumberLookup[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<HeadWeightNumberLookup[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const HeadWeightNumberLookupDB = new HeadWeightNumberLookupDatabase(db);
